
<template>
    <div>

        <div class="container">
            <div class="row">

                <div class="col-lg-12">
                    <h3 class="mb-0 text-uppercase">CPD Points</h3>
                    <hr class="my-4" />
                </div>

                <div 
                    class="table-responsive"
                    v-if="records.length > 0"
                >
                    
                    <table class="table table-bordered">

                        <thead>
                            <th>NAME</th>
                            <th>LICENSE YEAR</th>
                            <th>DATE</th>
                            <th>POINTS</th>
                            <th>&nbsp;</th>
                        </thead>

                        <tbody
                            v-for="record in records"
                            :key="record.id" 
                        >
                            <td>
                                <h4 class="text-capitalize font-weight-light">
                                    {{ record.name }}
                                </h4>
                            </td>
                            <td>
                                <h4 class="font-weight-light">
                                    {{ record.license_year }}
                                </h4>
                            </td>
                            <td>
                                <h4 class="font-weight-light">
                                    {{ record.date | formatDate }}
                                </h4>
                            </td>
                            <td>
                                <h4 class="font-weight-light">
                                    {{ record.point ? record.point : 'Not Allocated' }}
                                </h4>
                            </td>
                            <td>
                                <base-button tag="a" 
                                    type="primary" size="sm" 
                                    :href="record.file_url" 
                                    role="button" target="_blank"
                                    aria-pressed="true"
                                    :disabled="(privileges.view == 'no') || ! record.file_url"
                                >
                                <i class="fa fa-eye"></i> View File                          
                                </base-button>
                            </td>
                        </tbody> 

                        <!-- the total points is included here -->
                        <tbody>
                            <td colspan="3">
                                <h3 class="text-uppercase">
                                   Total Points Accumulated
                                </h3>
                            </td>
                            <td>
                                <h3 class="font-weight-bold text-uppercase">
                                    <strong class="text-warning">{{ total }}</strong> 
                                </h3>
                            </td>
                            <td>
                                <h4 class="font-weight-bold text-uppercase">
                                    Points
                                </h4>
                            </td>
                        </tbody> 
                        <!-- the total points ends here -->

                    </table>

                </div>

                <div 
                    v-if="records.length == 0"
                    class="col-sm-12 text-center"
                >
                    <base-alert type="warning">
                        <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                        <span class="alert-inner--text text-uppercase">
                            No CPD Points accumulated yet!!!
                        </span>
                    </base-alert>
                </div>

                <div class="col-lg-12">
                    <hr class="my-4" />
                </div>
            </div>  
        </div>

    </div>
</template>
<script>
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'CpdPoints',
        props: ['points', 'privileges', 'loadApplication'],
        filters: {
            formatDate(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        computed: {
            ...mapGetters(['userPhotoUrl']),
            records() {
                return this.points && this.points.records ? this.points.records : [];
            },
            total() {
                return this.points && this.points.total ? this.points.total : 0;
            }
        },
        methods: {
            ...mapActions(['updateUserCpdPoint']),
            // getCpdPointUrl(name) {
            //     return name ? this.userPhotoUrl+this.userId+'/documents/cpd/'+name : null;
            // }, 
            // updateCpdPoint(point) {// update CPD point
            //     swal.fire({
            //     title: 'Allocate point to '+ point.description +'\'s CPD Document',
            //     input: 'number',
            //     inputValue: point.point,
            //     inputAttributes: {
            //         autocapitalize: 'off'
            //     },
            //     showCancelButton: true,
            //     confirmButtonText: 'Allocate',
            //     showLoaderOnConfirm: true,
            //     preConfirm: (data) => {// save CPD point
            //         this.preloader(); // show loading
            //         this.updateUserCpdPoint({'id' : point.id, 'point' : data}).then((res) => {
            //             if(res.status) {
            //                 swal.fire('Point Allocated!', res.msg, 'success');
            //                 this.loadApplication();// reload page
            //             } else {
            //                 swal.fire('Error Occurred!', res.msg, 'error');
            //             }
            //         }).
            //         catch(() => {
            //             let msg = 'Server Failure!, Kindly reload the page...';
            //             swal.fire('Error Occurred!', msg, 'error');
            //         });
            //     },
            //         allowOutsideClick: () => !swal.isLoading()
            //     });
            // },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    };
</script>
<style scoped>
    .marginTop40 {
        margin-top: 40px;
    }
</style>
